import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
  Checkbox
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { getCities } from "../../../../redux/actions/countryCityActions";
import {
  add_cityAccess,
  getSalesPersonCities
} from "../../../../redux/actions/salesPersonActions";
import isEmpty from "lodash.isempty";
import {
  renderAlert,
  clearAlert
} from "../../../../redux/actions/alertsActions";
const history = createBrowserHistory();

let userID = "",
  isLoading = "false";
class CitiesPermission extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      citiesList: [],
      cityID: [],
      show: false,
      disabled: "",
      alertMessage: "",
      msgType: ""
    };
    this.handleCities = this.handleCities.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  componentWillMount() {
    userID = this.props.match.params.id ? this.props.match.params.id : "";
    this.props.getCities();
    isLoading = "true";
    let edit = this.props.match.params.edit ? this.props.match.params.edit : "";
    if (edit !== "") {
      const postaData = {
        salesManagerID: userID
      };
      this.props.getSalesPersonCities(postaData);
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.activecities !== nextProps.activecities &&
      !isEmpty(nextProps.activecities)
    ) {
      if (nextProps.activecities) {
        this.setState({ citiesList: nextProps.activecities });
        isLoading = "false";
      }
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ disabled: false });
      }
    }

    if (this.props.accessResponse !== nextProps.accessResponse) {
      if (nextProps.accessResponse) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.accessResponse.message);
        this.setState({ disabled: false });
        isLoading = "false";
      }
    }

    if (this.props.salesPersoncities !== nextProps.salesPersoncities) {
      if (nextProps.salesPersoncities) {
        isLoading = "false";
        if (
          nextProps.salesPersoncities.response !== "error" &&
          nextProps.salesPersoncities.data.length > 0
        ) {
          this.setState({
            salesPersoncities: nextProps.salesPersoncities.data
          });
          let cityID = [];
          nextProps.salesPersoncities.data.map((cities, index) =>
            cityID.push(cities.cityID)
          );

          this.setState({ cityID: cityID });
        }
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  validate = () => {
    let isError = false;
    const errors = {};
    if (this.state.cityID.length === 0) {
      isError = true;
      this.setState({ cityError: "(Please select at least one city.)" });
    }

    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ disabled: true });
    const err = this.validate();
    if (!err) {
      const postData = {
        salesManagerID: userID,
        city: this.state.cityID
      };
      this.props.add_cityAccess(postData);
    }
  }

  handleCities(e) {
    let salesPersoncities;
    const cityID = this.state.cityID;
    let index;
    if (e.target.checked) {
      this.setState({ cityError: "" });
      cityID.push(e.target.value);
    } else {
      salesPersoncities = this.state.salesPersoncities.splice(
        e.target.attributes.getNamedItem("data-tag").value,
        1
      );
      index = cityID.indexOf(e.target.value);
      cityID.splice(index, 1);
    }
    this.setState({ cityID: cityID });
    this.setState({ disabled: false });
  }

  render() {
    let cityCol = "",
      listCities = [];
    if (this.state.salesPersoncities) {
      this.state.salesPersoncities.map((city, index) =>
        listCities.push(city.cityID)
      );
    }

    if (this.state.citiesList.length > 0) {
      cityCol = this.state.citiesList.map((cityObject, index) => {
        let checked = listCities.indexOf(cityObject.cityID) > -1 ? true : false;
        let indexValue = listCities.indexOf(cityObject.cityID);
        return (
          <Col md={2} xs={4} key={index}>
            <FormGroup controlId={cityObject.title}>
              {listCities.indexOf(cityObject.cityID) > -1 ? (
                <Checkbox
                  name="city[]"
                  inline
                  key={index}
                  checked
                  value={cityObject.cityID}
                  data-tag={indexValue}
                  onChange={this.handleCities}
                >
                  {cityObject.title}
                </Checkbox>
              ) : (
                <Checkbox
                  name="city[]"
                  inline
                  key={index}
                  value={cityObject.cityID}
                  data-tag={indexValue}
                  onChange={this.handleCities}
                >
                  {cityObject.title}
                </Checkbox>
              )}
            </FormGroup>
          </Col>
        );
      });
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <form onSubmit={this.handleSubmit} encType="multipart/form-data">
          <div className="panel">
            <header className="panel-heading">Sales Person Permission</header>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}

            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={12} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Select Cities<span className="inline-validation-error">
                        {this.state.cityError !== ""
                          ? this.state.cityError
                          : " "}
                      </span>
                    </ControlLabel>
                  </Col>
                </Row>
                <Row>{cityCol}</Row>

                <Row className="BtnRow">
                  <Col md={12} xs={12}>
                    <Button
                      bsStyle="info"
                      type="submit"
                      id="saveButton"
                      disabled={this.state.disabled}
                    >
                      Save
                    </Button>
                    <Button
                      bsStyle="default"
                      onClick={() => this.context.router.history.push(`/userList`)}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activecities: state.countryCityReducers.activecities,
  accessResponse: state.salesPersonReducer.accessResponse,
  error: state.salesPersonReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  salesPersoncities: state.salesPersonReducer.salesPersoncities
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    getCities,
    add_cityAccess,
    getSalesPersonCities,
    renderAlert,
    clearAlert
  })
)(CitiesPermission);



// WEBPACK FOOTER //
// ./src/app/views/admin/subAdmin/citiesPermission/CitiesPermission.js